import React from "react";

interface TextBoxProps {
    label: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    labelWidth?: string;
    name?: string;
    type?: "text" | "number";
    step?: number | "any";
    containerStyle?: React.CSSProperties;
    labelStyle?: React.CSSProperties;
    inputStyle?: React.CSSProperties;
}

export const TextBox: React.FC<TextBoxProps> = ({
    label,
    value,
    onChange,
    placeholder = "",
    labelWidth = "100%",
    name,
    type = "text",
    step,
    containerStyle,
    labelStyle,
    inputStyle
}) => {
    return (
        <div className="row" style={containerStyle}>
            <label
                className="label"
                style={{ flex: `0 0 ${labelWidth}`, ...labelStyle }}
            >
                {label}
            </label>

            <div>
                <input
                    type={type}
                    step={step}
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    className="textbox"
                    style={inputStyle}
                />
            </div>
        </div>
    );
};